export class OrganisationUnit {
    id: any;
    name: string;
    uid: string;
    countryCode: string;
    allowLogin: boolean;
    maintenanceModeActive: boolean;
    imageFileId: string;
    type: "main" | "parent"
    parent: OrganisationUnit;
    forceTwoFactor: boolean;

}
